import ru from "@/locale/ru";
import en from "@/locale/en";

export default {
    en: en,
    ru: ru
};
